import type { InstabookAvailability, InstabookTripTime } from 'src/common/types/api/v4/instabook';

export const FORM_ID_BOOK_NOW_DIRECT = 'form-book-now-direct';

export type FormStep = 'details' | 'guest'; // soon insurance, later addons

export const DEPARTURE_DATE_FIELD = 'departDate';
export const DEPARTURE_TIME_FIELD = 'departTime';
/** ISO duration format `/common/utils/intervalToDurationIso/` */
export const DURATION_FIELD = 'duration';
export const CAPTAINED = 'captained';
export const ADULTS = 'adults';
export const OCCASION = 'occasion';
export const MESSAGE_TO_OWNER = 'messageToOwner';
// optional formStep2 'guest'
export const EMAIL = 'email';
export const FIRST_NAME = 'firstName';
export const PHONE = 'phone';

/** Used by duration and time fields, zero prefixed */
export const TIME_STRING_FORMAT = 'HH:mm:ss';
/**
 * Combined formState for both steps, where step 2 is optional only if !user
 * Form tries to maintain values in the format received from instabook availability API
 * To reduce custom transformers
 */
export type BookNowDirectFormState = {
  [DEPARTURE_DATE_FIELD]?: Date;
  /** `HH:mm:ss`, i.e. 24-hour 0-indexed, e.g. `01:00:00` or `16:00:00` */
  [DEPARTURE_TIME_FIELD]?: InstabookTripTime['min_start_time'];
  /** `HH:mm:ss`, i.e. 0-indexed `01:00:00` or `48:00:00` */
  [DURATION_FIELD]?: InstabookAvailability['trip_length'];
  /** One number from the `listing.captain_options` */
  [CAPTAINED]?: InstabookAvailability['captained'];
  [ADULTS]?: number;
  /**
   * Represents the event type from `Dropdown` (e.g., "Birthday", "Fishing").
   * Stored as string in form state but converted to number using OCCASIONS mapping
   * when posting to API. For example, "0" string maps to OCCASIONS.BIRTHDAY (0) number value
   */
  [OCCASION]?: string;
  [MESSAGE_TO_OWNER]?: string;
  // FormStep 2 'guest'
  [EMAIL]?: string;
  [FIRST_NAME]?: string;
  [PHONE]?: string;
};

/** Dates are not serializable in JSON */
export type BookNowDirectFormStateSerialized = Omit<
BookNowDirectFormState,
'departDate' | 'email' | 'first_name' | 'phone'
> & {
  /** Standard ISO Date string `2025-03-27T19:07:27.098Z`  */
  [DEPARTURE_DATE_FIELD]?: string;
};

export type SessionStorageData = {
  formData: BookNowDirectFormStateSerialized;
  listingId: string;
  instabookId: string;
};

export const PARAM_KEYS = {
  /** Required for /book-now-direct/checkout/ as input to checkout-session api */
  TRIP_PK: 'trip_pk',
  /** Used to persist formData between gmb-next and react-universal */
  SESSION_KEY: 'session_key',
  /** Used in stripe_success url for instabooks created using guest email */
  HASHED_ID: 'hashed_id',
};
